export default __webpack_public_path__ + "static/media/zido_3.625010f0.png";